<template>
    <div class="relative flex flex-col justify-evenly items-center ">
        <div class="flex flex-col items-center justify-center relative">
            <!-- Circle Timer -->
            <svg class="w-32 h-32 transform -rotate-90" viewBox="0 0 100 100">
                <circle class="text-gray-100" stroke="currentColor" stroke-width="6" fill="transparent" r="45" cx="50"
                    cy="50" />
                <circle class="text-[#f01e6b]" :stroke-dasharray="circumference" :stroke-dashoffset="progress"
                    stroke-linecap="round" stroke="currentColor" stroke-width="6" fill="transparent" r="45" cx="50"
                    cy="50" />
            </svg>

            <!-- Time -->

            <div class="text-[#f01e6b] text-2xl font-semibold absolute">
                {{ formattedTime }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted ,defineEmits } from 'vue'


const emit = defineEmits(['timeOut']);

const totalTime = 10 * 60 // 10 minutes in seconds
const timeLeft = ref(totalTime)
const interval = ref(null)



const radius = 45
const circumference = 2 * Math.PI * radius

const progress = computed(() => {
    const percent = timeLeft.value / totalTime
    return circumference * (1 - percent)
})

const formattedTime = computed(() => {
    const minutes = Math.floor(timeLeft.value / 60).toString().padStart(2, '0')
    const seconds = (timeLeft.value % 60).toString().padStart(2, '0')
    return `${minutes}:${seconds}`
})

onMounted(() => {
    interval.value = setInterval(() => {
        if (timeLeft.value > 0) {
            timeLeft.value--
        } else {
            clearInterval(interval.value);
            emit('timeOut');
        }
    }, 1000)
})

onUnmounted(() => {
    clearInterval(interval.value)
})
</script>

<style scoped>
circle {
    transition: stroke-dashoffset 1s linear;
}
</style>